// TODO: move to backend
export const keplrChains = {
  cosmos: 'cosmoshub-4',
  akash: 'akashnet-2',
  band: 'laozi-mainnet',
  chihuahua: 'chihuahua-1',
  comdex: 'comdex-1',
  juno: 'juno-1',
  kava: 'kava_2222-10',
  osmosis: 'osmosis-1',
  persistence: 'core-1',
  sentinel: 'sentinelhub-2',
  stargaze: 'stargaze-1',
  secret: 'secret-4',
  axelar: 'axelar-dojo-1',
  bitsong: 'bitsong-2b',
  cheqd: 'cheqd-mainnet-1',
  emoney: 'emoney-3',
  evmos: 'evmos_9001-2',
  fetch: 'fetchhub-3',
  kichain: 'kichain-2',
  lum: 'lum-network-1',
  rizon: 'titan-1',
  sifchain: 'sifchain-1',
  umee: 'umee-1',
  regen: 'regen-1',
  iris: 'irishub-1',
  starname: 'iov-mainnet-ibc',
  konstellation: 'darchub',
  gbridge: 'gravity-bridge-3',
  mantle: 'mantle-1',
  crescent: 'crescent-1',
  Injective: 'injective-1',
}
